export enum OrderStatusType {
    NEW = 31,
    CONFIRMED = 32,
    DELIVERED = 33,
    REJECTED = 34,
    CANCELED = 35,
    RECEIVED = 41,
    INVOICED = 42
}
